// constants/pipelineColumns.ts
// Default pipeline columns for the ATS Kanban (Phase 1 — PIPE-02)
// slugs must match matches.placement_status values in the DB
// Colors reference COLOR_STYLES keys from hooks/useKanbanColumns.ts

import type { PipelineColumnConfig } from '../types/pipeline';

export type { PipelineColumnConfig };

/**
 * Default 7-stage recruitment pipeline.
 * Used when missions.pipeline_config IS NULL.
 * slug values: 'identified' is new; others align with existing placement_status values.
 *
 * Column header colors (from UI-SPEC):
 *   identified  → bg-slate-100   text-slate-700
 *   contacted   → bg-indigo-100  text-indigo-700
 *   interview   → bg-violet-100  text-violet-700
 *   shortlisted → bg-amber-100   text-amber-700
 *   offer       → bg-orange-100  text-orange-700
 *   placed      → bg-emerald-100 text-emerald-700
 *   rejected    → bg-red-100     text-red-700
 */
export const DEFAULT_PIPELINE_COLUMNS: PipelineColumnConfig[] = [
  { slug: 'identified',  label: 'Identifié',       color: 'slate',   position: 0 },
  { slug: 'contacted',   label: 'Contacté',         color: 'indigo',  position: 1 },
  { slug: 'interview',   label: 'Entretien',        color: 'purple',  position: 2 },
  { slug: 'shortlisted', label: 'Shortlist client', color: 'amber',   position: 3 },
  { slug: 'offer',       label: 'Offre',            color: 'orange',  position: 4 },
  { slug: 'placed',      label: 'Placé',            color: 'emerald', position: 5 },
  { slug: 'rejected',    label: 'Refusé',           color: 'rose',    position: 6 },
];

/**
 * Header Tailwind classes per column slug — used by PipelineColumn component.
 * Aligns with PLACEMENT_STATUSES_MMR color scheme from MissionMatchResults.tsx.
 */
export const PIPELINE_COLUMN_HEADER_STYLES: Record<string, { bg: string; text: string }> = {
  identified:  { bg: 'bg-slate-100',   text: 'text-slate-700'   },
  contacted:   { bg: 'bg-indigo-100',  text: 'text-indigo-700'  },
  interview:   { bg: 'bg-violet-100',  text: 'text-violet-700'  },
  shortlisted: { bg: 'bg-amber-100',   text: 'text-amber-700'   },
  offer:       { bg: 'bg-orange-100',  text: 'text-orange-700'  },
  placed:      { bg: 'bg-emerald-100', text: 'text-emerald-700' },
  rejected:    { bg: 'bg-red-100',     text: 'text-red-700'     },
};
